function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { createElement } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import propsToCss from '../utils/propsToCss';
import { basePropTypes, handleProps } from './utils';
const StyledIconButton = styled(IconButton)`
  cursor: pointer;
  ${props => propsToCss(props)}
`;
const IconButtonGy = props => {
  const {
    label,
    tooltip,
    className,
    icon,
    visible,
    ...rest
  } = props;
  if (visible === false) {
    return null;
  }
  const content = /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    "aria-label": label,
    className: className
  }, handleProps(rest)), icon && /*#__PURE__*/createElement(icon), rest.children);
  if (!label && !tooltip || rest.disabled) {
    return content;
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: label || tooltip
  }, content);
};
IconButtonGy.propTypes = {
  ...basePropTypes,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.any,
  label: PropTypes.string
};
export default IconButtonGy;